import { Link } from "@tanstack/react-router";
import { Inbox, Logs, Target } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
    return (
        <div className="grid place-items-center h-screen w-screen">
            <div className="text-center space-y-6 p-0">
                {/* Large 404 text */}
                <div className="space-y-2">
                    <h1 className="text-6xl font-bold text-zinc-300 select-none">404</h1>
                    <div className="h-px bg-linear-to-r from-transparent via-neutral-200 to-transparent w-24 mx-auto" />
                </div>

                {/* Message */}
                <div className="space-y-3">
                    <h2 className="text-xl font-semibold text-zinc-700">Not Found</h2>
                    <p className="text-orsane-muted leading-relaxed max-w-sm mx-auto">
                        The item you're looking for doesn't exist or may have been moved.
                    </p>
                </div>

                {/* Action buttons */}
                <div className="flex flex-col sm:flex-row gap-3 pt-2">
                    <Button
                        variant="outline"
                        nativeButton={false}
                        className="flex-1"
                        render={
                            <Link to="/inbox">
                                <Inbox className="w-4 h-4" />
                                Inbox
                            </Link>
                        }
                    ></Button>

                    <Button
                        variant="outline"
                        nativeButton={false}
                        className="flex-1"
                        render={
                            <Link to="/assigned-to-me">
                                <Target className="w-4 h-4" />
                                Assigned to me
                            </Link>
                        }
                    ></Button>
                    <Button
                        variant="outline"
                        nativeButton={false}
                        className="flex-1"
                        render={
                            <Link to="/created-by-me">
                                <Logs className="w-4 h-4" />
                                All tasks
                            </Link>
                        }
                    ></Button>
                </div>
            </div>
        </div>
    );
}
